// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__2nofM","colMin":"styles_colMin__1Qrg0","colCheckbox":"styles_colCheckbox__1l0z8"};